module.exports = __webpack_public_path__ + "img/IMG_1539_L_Wood_MockedUp.b542d7f4.jpg";